export default __webpack_public_path__ + "static/angelina-ivanova-abcf79521991c79e93c950e7ebcf7868.jpg";